import { css } from 'lit';

export default css`
  /*  a lot of duplication between vst-ui-listbox and here */
  :host {
    background: var(--vst-color-bg);
    display: block;
    padding: var(--vst-space-s);
    max-block-size: 75vh;
    min-inline-size: max-content;
    overflow: auto;
    border: 1px solid var(--vst-color-popover-border);
  }

  .listbox__list {
    list-style: none;
    padding-inline-start: 0;
    margin: 0;
  }

  .listbox__item {
    border-bottom: 1px solid var(--vst-color-bg-secondary);
  }
  .listbox__item:last-of-type {
    border-bottom: 0;
  }
  .listbox__sub-options-label > select {
    width: max-content;
  }

  .listbox__sub-options-label {
    flex-direction: column;
    padding: 0 var(--vst-space-s) var(--vst-space-s) var(--vst-space-s);
    row-gap: var(--vst-space-2xs);
    display: flex;
  }

  .listbox__switch {
    display: block;
    padding: var(--vst-space-s);
  }

  .listbox__switch:has(+ label) {
    padding: var(--vst-space-s) var(--vst-space-s) var(--vst-space-xs) var(--vst-space-s);
  }
`;
